import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TramiteSuperintendeciaMercantilDto } from '../dto/tramites/tramite-superintendecia-mercantiles.dto';
import { TramiteResponseDTO } from '../dto/tramites/tramite.dto';

@Injectable({
  providedIn: 'root',
})
export class TramiteSuperintendeciaMercantilesService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/ssm/tramite/registrar-tramite';

  constructor(private http: HttpClient) {}

  crearTramiteSSM(
    data: TramiteSuperintendeciaMercantilDto
  ): Observable<TramiteResponseDTO> {
    return this.http.post<TramiteResponseDTO>(
      `${this.apiUrl}${this.baseUrl}`,
      data
    );
  }
}
